/* DON'T EDIT THIS FILE: edit original and run build again */ import { verifyEmailWithTokenCallName } from "../../framework/auth-verify-email-token-call/verify-email-with-token-call-name.ts";
import { TokenError } from "../../framework/token/token-error-codes.ts";

export enum VerifyEmailWithTokenCallError {
  internalError = "internalError",
}

export type VerifyEmailWithTokenCallResponseOk = { ok: true };

export type VerifyEmailWithTokenCallResponseError = {
  ok: false;
  error: VerifyEmailWithTokenCallError | TokenError;
};

export type VerifyTokenTokenCallResponse =
  | VerifyEmailWithTokenCallResponseOk
  | VerifyEmailWithTokenCallResponseError;

export type VerifyEmailWithTokenCall = {
  name: typeof verifyEmailWithTokenCallName;
  signature: (
    params:
      | {
          tokenCode: string;
        }
      | {
          tokenCode: string;
          uid: string;
          isPrefix: true;
        }
  ) => Promise<VerifyTokenTokenCallResponse>;
};
